import React from "react";
import { useStoreCartItemsHook } from "./store-cart-items-hooks";

type ContextStoreCartItems = ReturnType<typeof useStoreCartItemsHook>;
export const StoreCartItemsContext =
  React.createContext<ContextStoreCartItems | null>(null);

export function useContextStoreCartItems() {
  const context = React.useContext(StoreCartItemsContext);

  if (!context) {
    throw new Error(
      "useContextStoreCartItems must be used within a ContextStoreCartItemsProvider",
    );
  }

  return context;
}
